import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import classnames from 'classnames';

const Thumb = ({
  classes,
  url,
  currPage,
  pageNumber,
  handleClick,
  isDps,
  disableClick,
  nextUrl,
}) => {
  const onClick = () => {
    !disableClick && handleClick(currPage);
  };
  const page = isDps ? `${currPage} - ${currPage + 1}` : currPage;
  const currentStyle =
    pageNumber === currPage ? { fontWeight: 'bold', color: 'black' } : {};
  return (
    <Button
      disableRipple
      aria-label={`Go to page ${page}`}
      className={classnames(
        pageNumber === currPage && classes.pdfThumbCurrent,
        classes.pdfThumbItem
      )}
      classes={{ label: classes.pdfThumbLabel }}
      onClick={onClick}
    >
      <React.Fragment>
        <span
          className={classnames(
            classes.pdfThumbDpsContainer,
            classes.pdfThumbBorder
          )}
        >
          <img
            src={url}
            className={classes.pdfThumbImg}
            alt={`page ${currPage}`}
          />
          {isDps && (
            <img
              src={nextUrl}
              className={classes.pdfThumbImg}
              alt={`page ${currPage + 1}`}
            />
          )}
        </span>
        <Typography variant="caption" style={currentStyle}>
          {`${page}`}
        </Typography>
      </React.Fragment>
    </Button>
  );
};

export default Thumb;
